import './App.css';
import Header from './components/Header';
import MainContent from './components/MainContent';
import Registro from './components/Registro';
import Nosotros from './components/Nosotros';
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import Tienda from './components/Tienda';
import Noticias from './components/Noticias';
import PostDetalle from './components/PostDetalle';
import CrearPost from './components/CrearPost';
import RutaProtegida from './components/RutaProtegida';


import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

function RutaModerador({ children }) {
  const usuario = JSON.parse(localStorage.getItem('usuario'));

  if (!usuario || usuario.rol !== 'MODERADOR') {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <Router>
      <Header />

      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/tienda" element={<Tienda />} />
        <Route path="/noticias" element={<Noticias />} />

        <Route path="/noticias/:slug" element={<PostDetalle />} />

        <Route
          path="/moderador/crear-post"
          element={
            <RutaProtegida rolesPermitidos={["MODERADOR", "ADMIN"]}>
              <CrearPost />
            </RutaProtegida>
          }
        />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;